import './App.css';
import { createBrowserRouter, RouterProvider, useLocation } from 'react-router-dom';

import React, { useEffect } from 'react';
import Page from './components/Page';
import SEO from './components/SEO';
import Simple from './Pages/Configurator/Table/Simple';
import LandingPage from './Pages/Landing';
import MainPage from './Pages/Main';
import CatalougePage from './Pages/Configurator';
import NotFound from './Pages/NotFound';
import ContactUs from './Pages/ContactUs';
import Basket from './Pages/Basket';
import QuoteSent from './Pages/QuoteSent';
import Certificates from './Pages/Certificates';
import Distributors from './Pages/Distributors';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import CookiePolicy from './Pages/CookiePolicy';
import Blog from './Pages/Blog';
import BlogPost from './Pages/Blog/BlogPost';
import SearchResults from './Pages/SearchResults';
import RouteError from './components/RouteError';
import ItemCodeRedirect from './components/ItemCodeRedirect';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <ItemCodeRedirect>
        <MainPage />
      </ItemCodeRedirect>
    ),
    errorElement: <RouteError />,
  },
  { path: '/landing', element: <LandingPage />, errorElement: <RouteError /> },
  { path: '/contact', element: <ContactUs />, errorElement: <RouteError /> },
  {
    path: '/products/:id',
    element: <CatalougePage />,
    errorElement: <RouteError />,
  },
  {
    path: '/products',
    element: <CatalougePage />,
    errorElement: <RouteError />,
  },
  {
    path: '/products/:name/list/:itemcode',
    element: <Simple />,
    errorElement: <RouteError />,
  },
  {
    path: '/products/:name/list',
    element: <Simple />,
    errorElement: <RouteError />,
  },
  { path: '/search', element: <SearchResults />, errorElement: <RouteError /> },
  { path: '/basket', element: <Basket />, errorElement: <RouteError /> },
  {
    path: '/quote-success',
    element: <QuoteSent />,
    errorElement: <RouteError />,
  },
  {
    path: '/certificates',
    element: <Certificates />,
    errorElement: <RouteError />,
  },
  {
    path: '/distributors',
    element: <Distributors />,
    errorElement: <RouteError />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
    errorElement: <RouteError />,
  },
  {
    path: '/cookie-policy',
    element: <CookiePolicy />,
    errorElement: <RouteError />,
  },
  { path: '/blog', element: <Blog />, errorElement: <RouteError /> },
  { path: '/blog/:id', element: <BlogPost />, errorElement: <RouteError /> },
  { path: '*', element: <NotFound />, errorElement: <RouteError /> },
]);

// NOTE: RouterProvider does not render a `children` prop at all (React
// Router v6) - passing <AnalyticsTracker /> as its child, as this file
// previously did, was silently dropped and never rendered. GA route-change
// tracking has therefore never actually fired. Left unwired rather than
// restructured here (e.g. into a layout route) - that's a real fix, not a
// mechanical one, and needs its own pass.
const AnalyticsTracker = ({ trackingId }: { trackingId: string }) => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', trackingId, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location, trackingId]);

  return null;
};

function App() {
  return (
    <Page>
      <SEO />
      <RouterProvider router={router} />
    </Page>
  );
}

export default App;
